module.exports = __webpack_public_path__ + "static/media/microscope.086ed08a.svg";